// extracted by mini-css-extract-plugin
module.exports = {"infoRow":"Reprice__infoRow--10SfyUk51TtUxrH4Nb2wXQ"};